/* global $ */
import initFeefoSummary from "./components/feefo-summary";
class App
{
    bootstrap;

    constructor()
    {
        this.disableLogger();
        this.getBootstrap();
        this.initMenus();
        this.initMaps();
        this.initTooltips($('[data-bs-toggle="tooltip"]'));
        this.initToasts($('.toast'));
        this.initForms($('form'));
        this.initFontAwesome();
        this.initFancybox();
        this.initSlick();
        this.initMatrixBlock();
        this.initSearchLocations();
        this.initStickyMenu();
        this. initNavOpen();
        initFeefoSummary();
        $('body').css('opacity', 1);

        $(window).scroll(() => {
            this.initStickyMenu();
        });
        $(window).resize(() => {
            this.initStickyMenu();
        });

        if ('scrollRestoration' in history) {
            history.scrollRestoration = 'manual';
        }
        // Force scroll to top for all browsers, especially iOS Chrome/Safari
        const forceScrollToTop = () => {
            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
            window.scrollTo(0, 0);
        };
        
        // Immediate scroll
        forceScrollToTop();

        // After DOM is ready
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', forceScrollToTop);
        } else {
            forceScrollToTop();
        }

        // After full load with multiple attempts for iOS
        window.addEventListener('load', function () {
            forceScrollToTop();
            // Multiple timeouts to handle iOS Chrome's different rendering timing
            let attempts = 0;
            const fixScroll = () => {
                forceScrollToTop();
                if (attempts++ < 10) {
                    requestAnimationFrame(fixScroll);
                }
            };
            requestAnimationFrame(fixScroll);
        });
        
        window.addEventListener('pageshow', () => {
            forceScrollToTop();
        });

        console.log('App initialized');
        if ($('#formidable_file_check').length) {
            $('#formidable_file_check').find('#check-file-btn').on('click', function() {
                if(($('#file-check-field-file-1-input').get(0).files.length === 0 || $('#file-check-field-file-2-input').get(0).files.length === 0))
                {
                    alert("You must upload files");
                }
                else
                {
                    $('#check-file-submit').attr('disabled', false);
                    $('#check-file-submit').trigger('click');
                }
            })
        }
    }

    getBootstrap()
    {
        if (!this.bootstrap) {
            this.bootstrap = import(/* webpackChunkName: "bootstrap" */ 'bootstrap');
        }
        return this.bootstrap;
    }

    disableLogger()
    {
        if (window.Globals.env == 'production') {
            console.log = function() {};
        }
    }

    initFontAwesome()
    {
        if ($('.fa-brands, .fa-solid, .fa-regular, .fa-sharp, .fa-light, .fa-thin, .fa-duotone, .fa, .fas').length) {
            import(/* webpackChunkName: "fontawesome" */ './components/fontawesome');
            console.log('fontawsome initialised');
        }
        
    }

    initSlick() {
        import(/* webpackChunkName: "slick" */ './components/slick');
    }

    initFancybox() {
        if ($('.fancybox-image-gallery').length) {
            import(/* webpackChunkName: "fancybox" */ './components/fancybox');
        }
    }

    initForms($forms)
    {
        if ($forms.length) {
            import(/* webpackChunkName: "form" */ './components/form').then(chunk => {
                $.each($forms, (i, elem) => {
                    new chunk.Form($(elem));
                });
            });
        }
    }

    initToasts($elems)
    {
        if ($elems.length) {
            this.getBootstrap().then((bootstrap) => {
                $.each($elems, function (i, elem) {
                    new bootstrap.Toast(elem);
                });
            });
        }
    }

    initTooltips($elems)
    {
        if ($elems.length) {
            this.getBootstrap().then((bootstrap) => {
                $.each($elems, function (i, elem) {
                    new bootstrap.Tooltip(elem);
                });
            });
        }
    }

    initMatrixBlock() {
        if ($('.matrix-content').length) {
            import(/* webpackChunkName: "matrixblock" */ './components/matrixblock.js').then(matrixblock => {
                new matrixblock.Matrixblock;
            });
        }
    }

    initMenus() {
        if ($('.navbar-nav').length) {
            import(/* webpackChunkName: "menus" */ './components/menus');
        }
    }

    initMaps() {
        if ($('.map').length) {
            import(/* webpackChunkName: "maps" */ './components/maps');
        }
    }

    initSearchLocations(){
        if ($('.searched-locations').length) {
            import(/* webpackChunkName: "searchlocations" */ './components/searchlocations');
        }
    }
    addAlert(message, $elem, type = "danger", dismissible = false)
    {
        let _class = "alert alert-" + type;
        if (dismissible) {
            _class += ' alert-dismissible fade show';
            message += '<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>';
        }
        $('<div class="' + _class + '">' + message + '</div>').appendTo($elem);
    }

    addAlerts(messages, $elem, type = "danger", dismissible = false)
    {
        for (let i in messages) {
            this.addAlert(messages[i], $elem, type, dismissible);
        }
    }
    initNavOpen() {
        $(".navbar-toggler").click(() => {
            if ($(".navbar-toggler").hasClass("collapsed")) {
                $("body").removeClass("overflow-hidden");
            } else {
                $("body").addClass("overflow-hidden");
            }
        });
    }

    initStickyMenu() {
        let stickyNav = function () {
            let scrollTop = $(window).scrollTop();
            let headerHeight = $(".sticky").outerHeight();
            if (scrollTop > headerHeight) {
                $('#header').addClass('scrolled');
            } else {
                $('#header').removeClass('scrolled');
            }
        };
        stickyNav();
    }

}

export default App;